var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19734 2.4917H2.90028C2.49889 2.4917 2.11394 2.65115 1.83012 2.93498C1.54629 3.2188 1.38684 3.60375 1.38684 4.00514V14.5993C1.38684 15.0006 1.54629 15.3856 1.83012 15.6694C2.11394 15.9532 2.49889 16.1127 2.90028 16.1127H13.4944C13.8958 16.1127 14.2807 15.9532 14.5646 15.6694C14.8484 15.3856 15.0078 15.0006 15.0078 14.5993V9.3022",
    stroke: "#00AC4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8727 1.35689C14.1737 1.05584 14.582 0.886719 15.0078 0.886719C15.4335 0.886719 15.8418 1.05584 16.1429 1.35689C16.4439 1.65793 16.613 2.06623 16.613 2.49197C16.613 2.91771 16.4439 3.32601 16.1429 3.62705L8.95401 10.8159L5.92712 11.5726L6.68385 8.54574L13.8727 1.35689Z",
    stroke: "#00AC4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cc2a7933efd9b8f0cd259d2b8fcae580.svg";
export { ForwardRef as ReactComponent };